<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px'
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="奖品名称" prop="name">
              <a-input v-model="formInline.name" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="seach"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <lotteryActivityContent :formInline="formInline" ref="iason"></lotteryActivityContent>
      </div>
    </a-layout-content>
  </div>
</template>

<script>
import lotteryActivityContent from "./lotteryActivityContent.vue";
export default {
  components: {
    lotteryActivityContent
  },
  data() {
    return {
      formInline: {
        name: "",
        pageSize: 10,
        pageNo: 1
      }
    };
  },
  created() {},
  methods: {
    handleSubmit(e){
      console.log('handleSubmit:', e);
    },
    seach(e) {
      console.log(this.formInline);
      this.$refs.iason.activeTab = "prizes";
      this.$refs.iason.getPrizeData();
    },
    resetForm() {
      this.$refs.iason.activeTab = "prizes";
      this.formInline.name = "";
      this.$refs.iason.getPrizeData();
      
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/storeManagement/lotteryActivity/lotteryActivityHome.vue